import type { VFC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ModulesList } from './Content';

export const ModulesListRouter: VFC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <ModulesList />
      </Route>
    </Switch>
  );
};
